import { composeConfigs, PreviewWeb } from '@storybook/preview-web';
    import { ClientApi } from '@storybook/client-api';
    import '/virtual:/@storybook/builder-vite/setup-addons.js';
    import { importFn } from '/virtual:/@storybook/builder-vite/storybook-stories.js';

    const getProjectAnnotations = async () =>
      composeConfigs(await Promise.all([import('@storybook/html/dist/esm/client/preview/config'),
import('@storybook/html/dist/esm/client/docs/config'),
import('@storybook/addon-docs/preview.js'),
import('@storybook/addon-measure/preview.js'),
import('@storybook/addon-outline/preview.js'),
import('@storybook/addon-a11y/preview.js'),
import('/opt/build/repo/.storybook/preview.jsx')]));

    const preview = new PreviewWeb();

    window.__STORYBOOK_PREVIEW__ = preview;
    window.__STORYBOOK_STORY_STORE__ = preview.storyStore;
    window.__STORYBOOK_CLIENT_API__ = new ClientApi({ storyStore: preview.storyStore });

    preview.initialize({ importFn, getProjectAnnotations });
    
    if (import.meta.hot) {
      import.meta.hot.accept('/virtual:/@storybook/builder-vite/storybook-stories.js', (newModule) => {
      // importFn has changed so we need to patch the new one in
      preview.onStoriesChanged({ importFn: newModule.importFn });
      });

    import.meta.hot.accept(["@storybook/html/dist/esm/client/preview/config","@storybook/html/dist/esm/client/docs/config","@storybook/addon-docs/preview.js","@storybook/addon-measure/preview.js","@storybook/addon-outline/preview.js","@storybook/addon-a11y/preview.js","/opt/build/repo/.storybook/preview.jsx"], ([...newConfigEntries]) => {
      const newGetProjectAnnotations =  () => composeConfigs(newConfigEntries);

      // getProjectAnnotations has changed so we need to patch the new one in
      preview.onGetProjectAnnotationsChanged({ getProjectAnnotations: newGetProjectAnnotations });
    });
  };